import { useQuery } from '@tanstack/react-query';

import { useInstanceId } from '@frontend/hooks';

import { getAgentById, UnifiedAgent } from '../services/unifiedAgents';

type UnifiedAgentData = {
  agent: UnifiedAgent | undefined;
  agentType: 'specialized' | 'workflow' | undefined;
  isPending: boolean;
  error: Error | null;
};

export function useUnifiedAgentByHumanReadableId(humanReadableAgentId: string): UnifiedAgentData {
  const { instanceId } = useInstanceId();

  const {
    data: agent,
    isPending,
    error,
  } = useQuery<UnifiedAgent>({
    queryKey: getAgentById(instanceId ?? '', humanReadableAgentId).key,
    queryFn: getAgentById(instanceId ?? '', humanReadableAgentId).queryFn,
    enabled: !!instanceId && !!humanReadableAgentId,
  });

  return {
    agent,
    agentType: agent?.agent_type,
    isPending,
    error: error as Error | null,
  };
}
